import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { useDeviceLayout } from '@vio/atlas/context/deviceLayout';
import { Flex } from '@vio/atlas/helpers/Flex';
import { Text } from '@vio/atlas/Text';
import { getLanguageCode } from 'modules/meta/selectors';
import { useGetReviewsQuery } from 'modules/trustPilot';
import { times } from 'ramda';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { HomePageSectionTitle } from '../commonStyles';
import { HighlightedTitle } from '../HighlightedTitle';
import { TrustpilotDetails } from '../TrustpilotDetails';
import { TrustPilotReview } from './TrustPilotReview';
const Wrapper = /*#__PURE__*/styled('section')({
  name: "Wrapper",
  class: "wgrqr5s",
  propsAsIs: false
});
const EmptyBox = /*#__PURE__*/styled('section')({
  name: "EmptyBox",
  class: "e1gt5edc",
  propsAsIs: false
});
const ReviewsWrapper = /*#__PURE__*/styled('div')({
  name: "ReviewsWrapper",
  class: "r1nfl54n",
  propsAsIs: false
});
const _exp6 = /*#__PURE__*/() => Flex.Row;
const ReviewsGroup = /*#__PURE__*/styled(_exp6())({
  name: "ReviewsGroup",
  class: "rneegmo",
  propsAsIs: true
});
const HeaderWrapper = /*#__PURE__*/styled('div')({
  name: "HeaderWrapper",
  class: "hfq4fvc",
  propsAsIs: false
});
const _exp12 = /*#__PURE__*/() => Flex.Row;
const RatingDetailsWrapper = /*#__PURE__*/styled(_exp12())({
  name: "RatingDetailsWrapper",
  class: "r13boiws",
  propsAsIs: true
});
const TrustPilotReviewContainer = /*#__PURE__*/styled('div')({
  name: "TrustPilotReviewContainer",
  class: "txiafp0",
  propsAsIs: false
});
const RatingDetailsCard = /*#__PURE__*/styled('div')({
  name: "RatingDetailsCard",
  class: "ruhla0v",
  propsAsIs: false
});
const SocialProofDetails = /*#__PURE__*/styled('div')({
  name: "SocialProofDetails",
  class: "s1ohgqcd",
  propsAsIs: false
});
interface Props {
  // If true, the animation of the reviews will be stopped. This is used for taking storybook snapshots.
  stopAnimation?: boolean;
}
export const SocialProofSection: React.FC<Props> = ({
  stopAnimation
}) => {
  const languageCode = useSelector(getLanguageCode);
  const {
    data
  } = useGetReviewsQuery({
    language: languageCode,
    stars: 5
  });
  const {
    isDesktop
  } = useDeviceLayout();
  const reviews = useMemo(() => data?.reviews?.length && <ReviewsGroup gap="s500" alignItems="center" className={cx(stopAnimation && '__stopAnimation')}>
          {data.reviews.map(review => <TrustPilotReviewContainer key={review.id}>
              <TrustPilotReview review={review} />
            </TrustPilotReviewContainer>)}
        </ReviewsGroup>, [data, stopAnimation]);
  if (!reviews) return <EmptyBox />;
  return <Wrapper>
      <HeaderWrapper>
        <Flex.Column justifyContent="center" alignItems="center">
          <HomePageSectionTitle variant={isDesktop ? 'title4XL' : 'titleXL'} className="__center">
            <HighlightedTitle source="SocialProofSection" />
          </HomePageSectionTitle>
          <Text tag="div" variant={isDesktop ? 'title3XL' : 'titleL'}>
            <FormattedMessageWrapper id="homePage.socialProofSubtitle" defaultMessage="(in a good way)" />
          </Text>
        </Flex.Column>
      </HeaderWrapper>
      <SocialProofDetails>
        <RatingDetailsWrapper isReversed>
          <RatingDetailsCard>
            <TrustpilotDetails section="SocialProof" />
          </RatingDetailsCard>
        </RatingDetailsWrapper>
        <ReviewsWrapper>
          <Flex.Row id="trustpilot-reviews" gap="s500">
            {/* The reviews are duplicated to create an illusion of continuity for an animation,
                to ensure a seamless and continuous display of reviews. */}
            {times(() => reviews, stopAnimation ? 1 : 2)}
          </Flex.Row>
        </ReviewsWrapper>
      </SocialProofDetails>
    </Wrapper>;
};

require("./SocialProofSection.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SocialProofSection.tsx");